import {
  ADD_REMOVE_ACCOMMODATION_LEG_LOGS,
  ADD_REMOVE_ROUTE_LEG_LOGS,
  ADD_REMOVE_SABRE_COMMERCIAL_LEG_LOGS,
  HUB_LOGS,
  SUGGESTED_ROUTES_APPLIED_LOGS,
  MODIFIED_AVIA_ROUTE_LEG_LOGS,
  MODIFIED_GROUND_ROUTE_LEG_LOGS,
  GROUND_TRIP_ASSIGNED_LOGS,
  GROUND_TRIP_REASSIGNED_LOGS,
} from '@lp/features/RoutePlanner/components/LogisticsChangeLog/consts';
import {
  AccommodationLegModifiedLog,
  AddRemoveAccommodationChangeLog,
  AddRemoveLogisticsChangeLog,
  AddRemoveSabreChangeLog,
  GroundTripAssignedLog,
  GroundTripReassignedLog,
  LogisticsChangeLog,
  LogisticsChangeLogType,
  ModifiedLogisticsChangeLog,
  ModifiedLogisticsChangeLogAvia,
  ModifiedLogisticsChangeLogGround,
  RouteHubLog,
  RouteRemovedLog,
  SuggestedRoutesAppliedLog,
} from '@/api/apis/route';

export const isAddRemoveRouteLegLogs = (log: LogisticsChangeLog): log is AddRemoveLogisticsChangeLog =>
  ADD_REMOVE_ROUTE_LEG_LOGS.includes(log.$type);

export const isModifiedAviaRouteLegLogs = (log: LogisticsChangeLog): log is ModifiedLogisticsChangeLogAvia =>
  MODIFIED_AVIA_ROUTE_LEG_LOGS.includes(log.$type);
export const isModifiedGroundRouteLegLogs = (log: LogisticsChangeLog): log is ModifiedLogisticsChangeLogGround =>
  MODIFIED_GROUND_ROUTE_LEG_LOGS.includes(log.$type);
export const isAccommodationLegModifiedLog = (log: LogisticsChangeLog): log is AccommodationLegModifiedLog =>
  log.$type === LogisticsChangeLogType.AccommodationLegModifiedLog;
export const isModifiedRouteLegLogs = (log: LogisticsChangeLog): log is ModifiedLogisticsChangeLog =>
  isModifiedAviaRouteLegLogs(log) || isModifiedGroundRouteLegLogs(log);

export const isAddRemoveAccommodationLegLogs = (log: LogisticsChangeLog): log is AddRemoveAccommodationChangeLog =>
  ADD_REMOVE_ACCOMMODATION_LEG_LOGS.includes(log.$type);

export const isModifiedAccommodationLegLog = (log: LogisticsChangeLog): log is AccommodationLegModifiedLog =>
  log.$type === LogisticsChangeLogType.AccommodationLegModifiedLog;

export const isHubLogs = (log: LogisticsChangeLog): log is RouteHubLog => HUB_LOGS.includes(log.$type);
export const isRouteRemovedLogs = (log: LogisticsChangeLog): log is RouteRemovedLog =>
  log.$type === LogisticsChangeLogType.RouteRemovedLog;
export const isSuggestedRoutesAppliedLogs = (log: LogisticsChangeLog): log is SuggestedRoutesAppliedLog =>
  SUGGESTED_ROUTES_APPLIED_LOGS.includes(log.$type);
export const isAddRemoveSabreLogs = (log: LogisticsChangeLog): log is AddRemoveSabreChangeLog =>
  ADD_REMOVE_SABRE_COMMERCIAL_LEG_LOGS.includes(log.$type);
export const isRouteLogWithLegList = (log: LogisticsChangeLog): log is RouteRemovedLog | AddRemoveSabreChangeLog =>
  isRouteRemovedLogs(log) || isAddRemoveSabreLogs(log);
export const isGroundTripAssignedLogs = (log: LogisticsChangeLog): log is GroundTripAssignedLog =>
  GROUND_TRIP_ASSIGNED_LOGS.includes(log.$type);
export const isGroundTripReassignedLogs = (log: LogisticsChangeLog): log is GroundTripReassignedLog =>
  GROUND_TRIP_REASSIGNED_LOGS.includes(log.$type);
